/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['http', './utils', 'security', 'endpoints', './search/batchSearch'],
    function(http, utils, security, endpoints, batchSearch) {
        'use strict';

        var queryParamNames = [
            'spatialKeys', 'returnSpeedLimit', 'heading', 'radius',
            'number', 'returnRoadUse', 'roadUse', 'language'
        ];

        return {
            reverseGeocode: function(options, callback) {
                var pathParams = {}, queryParams = {};

                // Required parameter: position
                pathParams.position = utils.required(options.position,
                    '"position" parameter is required for reverseGeocode service.');

                // if an API key is specified, include it
                // an API key can be omitted if an API proxy is being used
                queryParams.key = utils.or(options.key, security.getKey('services/search'));
                pathParams.type = utils.required(options.type, 'Missing type definition in Search service');

                // optional parameters (spatialKeys, returnSpeedLimit, heading, radius, number, returnRoadUse,
                // roadUse) look for optional passed params and set them if they are not undefined
                utils.extractQueryParams(options, queryParams, queryParamNames);

                http.get({
                    url: '{protocol}://' + endpoints.reverseGeocode,
                    pathParameters: pathParams,
                    queryParameters: queryParams,
                    callback: callback,
                    callbackParam: 'callback',
                    fail: options.fail
                });
            },
            batch: batchSearch(queryParamNames, { queryFieldName: 'position'})
        };
    }
);



// WEBPACK FOOTER //
// ./rest/reverseGeocode.js